import { render, staticRenderFns } from "./materialCost.vue?vue&type=template&id=24fbdba6&scoped=true&"
import script from "./materialCost.vue?vue&type=script&lang=js&"
export * from "./materialCost.vue?vue&type=script&lang=js&"
import style0 from "./materialCost.vue?vue&type=style&index=0&id=24fbdba6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fbdba6",
  null
  
)

export default component.exports